(() => {
  const handles = ['hexpod-single-bundle', 'hexpod-starter-bundle', 'hexpod-starter-bundle-plus'];
  if (!handles.some(h => location.pathname.endsWith('/products/' + h))) return;
  const text = JSON.parse(document.getElementById('hp-builder-text').textContent);
  const brands = ['Supreme Trimmer','Supreme','StyleCraft','Babyliss','Andis','Braun','Bway','Caliber','Cocco','Gamma','Hush','JRL','Jucai','Kemei','Kulilang','Matsui','Monster','Novah','Oster','Suprent','TPOB','UNKWN','Universal','VGR','WMARK','Wahl'];
  function parts(value) {
    const prefix = brands.find(b => value.toLowerCase().startsWith(b.toLowerCase() + ' ')) || text.other;
    const brand = /^Supreme/.test(prefix) ? 'Supreme Trimmer' : ['StyleCraft','Gamma'].includes(prefix) ? 'StyleCraft / Gamma+' : prefix;
    const voltage = value.match(/\s+-\s+(\d+(?:\.\d+)?v.*)$/i);
    const model = (voltage ? value.slice(0, voltage.index) : value).replace(new RegExp('^' + (prefix === text.other ? '$^' : prefix) + '\\s+', 'i'), '').replace(/^SC\s+/, '');
    const version = value === 'Wahl 5Star-Shaver Insert - 4v(Finale BLK' ? '4V — Finale Black / Shaper Red' : voltage ? voltage[1] : value;
    return { brand, model, version };
  }
  function field(labelText, placeholder) {
    const label = document.createElement('label'); label.className = 'hp-builder-field';
    const caption = document.createElement('span'); caption.textContent = labelText;
    const select = document.createElement('select'); select.required = true;
    select.appendChild(new Option(placeholder, '')); label.append(caption, select);
    return { label, select };
  }
  function emit(select) { select.dispatchEvent(new Event('change', { bubbles: true })); }
  function setup(root) {
    if (root.dataset.hpReady) return;
    const source = [...root.querySelectorAll('select[name^="properties["]')];
    if (!source.length) return;
    root.dataset.hpReady = 'true';
    const banner = document.createElement('p'); banner.className='hp-builder-banner'; banner.textContent=text.preview;
    root.prepend(banner);
    source.forEach((native, index) => {
      const label = [...root.querySelectorAll('label')].find(l => l.htmlFor === native.id);
      native.value = ''; emit(native);
      if (!/insert/i.test(native.name)) return;
      const options = [...native.options].filter(o => o.value && o.value !== 'Shaper RED)').map(o => ({o,...parts(o.value)}));
      const box = document.createElement('section'); box.className = 'hp-builder-pod';
      const heading = document.createElement('h3'); heading.textContent = text.pod + ' ' + (index + 1);
      const grid = document.createElement('div'); grid.className = 'hp-builder-grid';
      const brand = field(text.brand, text.chooseBrand), model = field(text.model, text.chooseModel), version = field(text.version, text.chooseVersion);
      const summary = document.createElement('p'); summary.className='hp-builder-summary'; summary.setAttribute('aria-live','polite');
      const help = document.createElement('p'); help.className='hp-builder-help'; help.textContent=text.voltageHelp; help.hidden=true;
      const versionWrap = document.createElement('div');versionWrap.append(version.label,help);versionWrap.hidden=true;
      model.select.disabled=true;version.select.disabled=true;
      [...new Set(options.map(o=>o.brand))].sort().forEach(b=>brand.select.add(new Option(b,b)));
      grid.append(brand.label, model.label);box.append(heading,grid,versionWrap,summary);
      native.before(box);native.hidden=true;if(label)label.hidden=true;
      function clear() { native.value='';emit(native);summary.textContent=''; }
      function selected() {
        const option = options.find(o=>o.o.value===version.select.value&&o.brand===brand.select.value&&o.model===model.select.value);
        native.value=option && !option.o.disabled ? option.o.value : ''; emit(native);
        summary.textContent=native.value ? text.selected + ': ' + brand.select.value + ' · ' + model.select.value + (versionWrap.hidden ? '' : ' · ' + option.version) : '';
      }
      brand.select.addEventListener('change',()=>{
        clear();model.select.replaceChildren(new Option(text.chooseModel,''));version.select.replaceChildren(new Option(text.chooseVersion,''));
        version.select.disabled=true;versionWrap.hidden=true;
        model.select.disabled=!brand.select.value;
        [...new Set(options.filter(o=>o.brand===brand.select.value).map(o=>o.model))].sort().forEach(m=>model.select.add(new Option(m,m)));
      });
      model.select.addEventListener('change',()=>{
        clear();version.select.replaceChildren(new Option(text.chooseVersion,''));
        const matching=options.filter(o=>o.brand===brand.select.value&&o.model===model.select.value);
        matching.forEach(o=>{const opt=new Option(o.version,o.o.value);opt.disabled=o.o.disabled;version.select.add(opt);});
        version.select.disabled=!matching.length;versionWrap.hidden=!matching.length;
        help.hidden=!matching.some(o=>/\d+(?:\.\d+)?v/i.test(o.version));
        if(matching.length===1&&!matching[0].o.disabled){version.select.value=matching[0].o.value;versionWrap.hidden=true;selected();}
      });
      version.select.addEventListener('change',selected);
      new MutationObserver(()=>{
        [...version.select.options].forEach(o=>{const original=options.find(x=>x.o.value===o.value);if(original)o.disabled=original.o.disabled;});
        if(native.selectedOptions[0]?.disabled&&native.value){clear();version.select.value='';}
      }).observe(native,{subtree:true,attributes:true,attributeFilter:['disabled']});
    });
    const panel=source.find(s=>/Panel/i.test(s.name));
    if(panel){
      const panelLabel=[...root.querySelectorAll('label')].find(l=>l.htmlFor===panel.id);
      const panelBox=document.createElement('section');panelBox.className='hp-builder-panel';
      if(panelLabel)panelBox.append(panelLabel);
      panelBox.append(panel);
      const note=document.createElement('p');note.className='hp-builder-help';note.textContent=text.panelHelp;panelBox.append(note);
      banner.after(panelBox);
    }
  }
  function scan(){document.querySelectorAll('#simple-bundles-io-options').forEach(setup);}
  function validate(event){
    const roots=[...document.querySelectorAll('#simple-bundles-io-options[data-hp-ready]')];
    for(const root of roots){
      const missing=[...root.querySelectorAll('select')].find(s=>!s.disabled&&!s.hidden&&!s.closest('[hidden]')&&!s.value);
      if(missing){event.preventDefault();event.stopImmediatePropagation();missing.reportValidity();missing.focus();return;}
      if([...root.querySelectorAll('select[name^="properties["]')].some(s=>!s.value||s.selectedOptions[0]?.disabled)){
        event.preventDefault();event.stopImmediatePropagation();return;
      }
    }
  }
  document.addEventListener('submit',e=>{if(e.target.matches('form[action*="cart/add" i]'))validate(e);},true);
  document.addEventListener('click',e=>{if(e.target.closest('form[action*="cart/add" i] [type="submit"]'))validate(e);},true);
  new MutationObserver(scan).observe(document.body,{childList:true,subtree:true});scan();
})();
